import { CheckCircle2 } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Reveal } from "@/components/common/Reveal";
import { ABOUT } from "@/utils/constants";

export const About = () => (
  <Section id="about" testId="about-section" bg="charcoal" blueprint blueprintOpacity={0.15} containerClassName="grid lg:grid-cols-2 gap-12 items-center">
    <Reveal>
      <div className="relative">
        <div className="absolute -inset-3 bg-weld/10 blur-2xl rounded-3xl" />
        <img src={ABOUT.image} alt={ABOUT.alt} loading="lazy" className="relative w-full aspect-[4/3] object-cover clip-frame border border-weld/20" style={{ objectPosition: "center center" }} />
      </div>
    </Reveal>

    <Reveal delay={0.12}>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">About Deuce's</p>
      <h2 className="font-display text-5xl md:text-6xl text-white leading-none">{ABOUT.heading}</h2>
      {ABOUT.body.map((p, i) => (
        <p key={i} className="text-white/65 mt-5 leading-relaxed">{p}</p>
      ))}
      <ul className="mt-6 grid sm:grid-cols-2 gap-3">
        {ABOUT.points.map((pt) => (
          <li key={pt} className="flex items-center gap-2 text-white/75 text-sm">
            <CheckCircle2 className="text-weld shrink-0" size={16} /> {pt}
          </li>
        ))}
      </ul>
    </Reveal>
  </Section>
);
